<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fmtitle1">Abbreviations Used in the Notes</h2>
<p class="center">ACHS: Adams County Historical Society, Gettysburg, PA</p>
<p class="center">ANV: Army of Northern Virginia</p>
<p class="center">AOP: Army of the Potomac</p>
<p class="center">BSF: Brandy Station Foundation, Brandy Station, VA</p>
<p class="center">C&amp;O: Chesapeake &amp; Ohio</p>
<p class="center">CCHS: Cumberland County Historical Society, Carlisle, PA</p>
<p class="center">CV: Confederate Veteran</p>
<p class="center">CWTI: Civil War Times Illustrated</p>
<p class="center">FSNMP: Fredericksburg and Spotsylvania Military Park, Fredericksburg, VA</p>
<p class="center">GNMP: Gettysburg National Military Park, Gettysburg, PA</p>
<p class="center">HL: Huntington Library, San Marino, CA</p>
<p class="center">HSOPRF: Historical Society of Oak Park and River Forest, IL</p>
<p class="center">HSP: Historical Society of Pennsylvania, Philadelphia, PA</p>
<p class="center">JCPL: Jasper County Public Library, Rensselaer, IN</p>
<p class="center">JMSIUS: Journal of the Military Service Institution of the United States</p>
<p class="center">KHS: Kittochtinny Historical Society, Chambersburg, PA</p>
<p class="center">LCHS: Lancaster County Historical Society, Lancaster, PA</p>
<p class="center">LOC: Library of Congress, Washington, DC</p>
<p class="center">MDAH: Mississippi Department of Archives and History, Jackson, MS</p>
<p class="center">MGRR: Manassas Gap Railroad</p>
<p class="center">MHACV: Mennonite Historical Association of the Cumberland Valley, Chambersburg, PA</p>
<p class="center">MOLLUS: Military Order of the Loyal Legion of the United States</p>
<p class="center">NARA: National Archives and Records Administration, Washington, DC</p>
<p class="center">NCSA: North Carolina State Archives, Raleigh, NC</p>
<p class="center">NT: The National Tribune</p>
<p class="center">NYSNG: New York State National Guard</p>
<p class="center">OR: Official Records of the War of the Rebellion</p>
<p class="center">PRR: Pennsylvania Railroad</p>
<p class="center">SCV: Sons of Confederate Veterans</p>
<p class="center">SHC-UNC: Southern Historical Collection, Wilson Library, Univ. of North Carolina, Chapel Hill</p>
<p class="center">SHSP: Southern Historical Society Papers</p>
<p class="center">UGA: Univ. of Georgia, Athens, GA</p>
<p class="center">UM: Univ. of Michigan, Ann Arbor, MI</p>
<p class="center">UNC: Univ. of North Carolina, Chapel Hill, NC</p>
<p class="center">USAHEC: United States Army Heritage and Education Center, Carlisle, PA</p>
<p class="center">UVA: Univ. of Virginia, Charlottesville, VA</p>
<p class="center">VHS: Virginia Historical Society, Richmond, VA</p>
<p class="center">VMI: Virginia Military Institute, Lexington, VA</p>
<p class="center">VOTS: Valley of the Sun, a Civil War website of the Univ. of Virginia</p>
<p class="center">YCHC: York County History Center, York, PA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?b5f77612